const POPUP_STORAGE_KEY = "mussen_favorite_popup_time";
const NAV_URL_STORAGE_KEY = "mussen_nav_url_list";
const DEFAULT_NAV_URLS = ["3p10.cn", "3p11.cn", "3p12.cn", "3p13.cn", "3p14.cn"];

function buildSvgDataUrl(title, subtitle, colors, size) {
  const safeTitle = String(title).replace(/[&<>"]/g, "");
  const safeSubtitle = String(subtitle).replace(/[&<>"]/g, "");
  const [width, height] = size;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${colors[0]}" />
          <stop offset="100%" stop-color="${colors[1]}" />
        </linearGradient>
      </defs>
      <rect width="${width}" height="${height}" fill="url(#g)" />
      <circle cx="${width - 48}" cy="48" r="32" fill="rgba(255,255,255,0.14)" />
      <text x="20" y="${height / 2 - 10}" font-size="20" fill="#ffffff" font-family="Arial, Microsoft YaHei">3P影视</text>
      <text x="20" y="${height / 2 + 18}" font-size="14" fill="rgba(255,255,255,0.88)" font-family="Arial, Microsoft YaHei">${safeTitle}</text>
      <text x="20" y="${height - 18}" font-size="12" fill="rgba(255,255,255,0.72)" font-family="Arial, Microsoft YaHei">${safeSubtitle}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export function getCoverUrl(video) {
 
}

export function getBannerUrl(ad) {

}

export function getDetailId(route) {
  const id = Number(route && route.query ? route.query.id : 0);
  return Number.isFinite(id) && id > 0 ? id : 1;
}

export function normalizeNavUrlList(navUrlList) {
  if (!Array.isArray(navUrlList)) {
    return [];
  }

  return navUrlList
    .map((item) => {
      if (typeof item === "string") {
        return item.trim();
      }
      if (item && typeof item === "object") {
        return String(item.url || item.domain || item.name || item.title || "").trim();
      }
      return "";
    })
    .filter(Boolean);
}

export function cacheNavUrlList(navUrlList) {
  const normalized = normalizeNavUrlList(navUrlList);
  if (!normalized.length || typeof window === "undefined") {
    return normalized;
  }
  window.localStorage.setItem(NAV_URL_STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function getCachedNavUrlList() {
  if (typeof window === "undefined") {
    return [...DEFAULT_NAV_URLS, DEFAULT_NAV_URLS[0]];
  }

  try {
    const cached = JSON.parse(window.localStorage.getItem(NAV_URL_STORAGE_KEY) || "[]");
    const normalized = normalizeNavUrlList(cached);
    const source = normalized.length ? normalized : DEFAULT_NAV_URLS;
    return [...source, source[0]];
  } catch (error) {
    return [...DEFAULT_NAV_URLS, DEFAULT_NAV_URLS[0]];
  }
}

export function decryptApiPayload(payload, decryptFn) {
  if (payload === null || payload === undefined || payload === "") {
    return null;
  }

  if (typeof payload === "object") {
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload.code === 1 && payload.data !== undefined) {
      return payload.data;
    }
    return payload;
  }

  if (typeof decryptFn !== "function") {
    return null;
  }

  try {
    const decryptedText = decryptFn(payload);
    return decryptedText ? JSON.parse(decryptedText) : null;
  } catch (error) {
    return null;
  }
}

export async function copyCurrentLink() {
  const text = window.location.href;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return text;
  }

  const input = document.createElement("input");
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  return text;
}

export function shouldShowFavoritePopup() {
  // const lastShown = Number(window.localStorage.getItem(POPUP_STORAGE_KEY) || 0);
  // const oneDay = 24 * 60 * 60 * 1000;
  // return !lastShown || Date.now() - lastShown > oneDay;
}

export function markFavoritePopupShown() {
  window.localStorage.setItem(POPUP_STORAGE_KEY, String(Date.now()));
}
